import React, { useEffect, useState } from 'react'
import api from "../services/api"
import { Badge, Form } from 'react-bootstrap';
import { defaultHeaders, isAdmin, ReadDataStorage, TOKEN_KEY } from '../services/auth'

import { width } from "../helpers";

import { Button } from "reactstrap";
import '@fortawesome/fontawesome-free/css/all.css';
import { NotificationContainer } from 'react-notifications';

import ReactLoading from 'react-loading';

import { format, eachDayOfInterval, getDay, addDays, endOfWeek, startOfWeek } from 'date-fns'
import Agendamento from './modals/Agendamento'
import FilterPeriodo from './modals/filter-periodo'

export default function Agenda(props) {
    const [loading, setLoading] = useState(false)
    const [modal, setModal] = useState(false)
    const [modalPeriodo, setModalPeriodo] = useState(false)
    const [reload, setReload] = useState(false)

    const [colaboradores, setColaboradores] = useState([])
    const [colaboradoresList, setColaboradoresList] = useState([])
    const [tipoAgendamento, setTipoAgendamento] = useState([])

    const [events, setEvents] = useState([])
    const [agendamentos, setAgendamentos] = useState([])
    const [totalEvents, setTotalEvents] = useState(0)
    const [data, setData] = useState({})
    const [showFilter, setShowFilter] = useState(false)
    const [idTecnico, setIdTecnico] = useState(0)

    const [periodo, setPeriodo] = useState([])
    const [idCalendarList, setIDCalendarList] = useState(0)
    const [dates, setDates] = useState([])
    const [datesInWeek, setDatesInWeek] = useState([])
    const [grupos, setGrupos] = useState([])
    const [grupo, setGrupo] = useState(localStorage.getItem("agenda.grupo"))
    const [temp, setTemp] = useState(false)

    const getUser = () => {
        if (isAdmin())
            return 0
        else
            return JSON.parse(ReadDataStorage(TOKEN_KEY))['PESSOAID']

    }

    const handleReload = () => {

        // setTemp(!temp)
        // getTipoAgendamento()
        // Reduce(idTecnico)
        Filters(getUser())

    }

    const handleCallback = () => {
        setModal(false)
        // handleReload()
    }

    const clearFilters = (_id) => {
        tipoAgendamento.map((item, id) => {
            return (tipoAgendamento[id].CHECKED = false)
        })
        Reduce(_id)
    }

    const handleFilter = (value) => {

        setGrupo(value)
        localStorage.setItem("agenda.grupo", value);
    }

    const handleTipoAgendamento = (key) => {
        tipoAgendamento.map((item, id) => {
            if (key.ID === item.ID)
                return (tipoAgendamento[id].CHECKED = !tipoAgendamento[id].CHECKED)
            else
                return (null)

        })
        Reduce(idTecnico)
    }

    const newShedulling = (_date) => {
        setData(_date)
        // setData(_date?.startStr || _date)
        setModal(true)
    }

    const handleEdit = (_data) => {
        setData(_data.dataEvent)
        setModal(true)
    }

    const getTipoAgendamento = async () => {
        await api.get('/agenda/buscartipos',{}, { headers: defaultHeaders() })
            .then(response => {
                let _aux = []
                response.data.map((item) => {
                    item.CHECKED = false
                    _aux.push(item)
                    return (false)
                })
                setTipoAgendamento(_aux)
            })
            .catch(error => {
            })
    }

    const Filters = async (idtecnico) => {
        let _iniDate = periodo[0] !== undefined ? periodo[0].startDate : new Date()
        let _finDate = periodo[0] !== undefined ? periodo[0].endDate : addDays(new Date(), 30)

        let _body = {
            "empresaid": 11443,
            "datai": addDays(_iniDate, -1),
            "tipo": 'TODOS',
            "dataf": _finDate,
            'tecnicoid': idtecnico || 0,
        }

        setLoading(true)
        console.log("agenda.buscarAgendamentos(0): ", _body)
        await api.post('/agenda/buscaragendamentos', _body, { headers: defaultHeaders() })

            .then(response => {
                let _aux = []

                setAgendamentos(response.data.agendamentos)
                let _go = false
                response.data.agendamentos.map((item) => {
                    if (!_go) {
                        _go = true
                    }
                    if (!grupo || grupo === "Todos" || grupo === item.GRUPOCOLABORADORES)
                        return _aux.push({
                            id: item.AGENDAID,
                            color: '#' + item.COR,
                            textColor: ["ffff"].includes(item?.COR?.substring(0, 4)?.toLowerCase()) ? '#000' : '#fff',
                            tecnico: item.TECNICO,
                            resourceId: item.TECNICOID,
                            starthour: item.HORA_INI,
                            start: item.DATA_INI.substring(0, 10),
                            end: item.DATA_FIN === null ? '' : item.DATA_FIN.substring(0, 10) + 'T' + item.HORA_FIN,
                            title: (item.CLIENTE === null ? "(Cliente Não Informado)" : titleCase(item.CLIENTE)),
                            CNPJ_CPF: item.CNPJ_CPF || 'CNPJ não informado',
                            Cidade: item.CIDADECLI,
                            UF: item.UFCLI,
                            dataEvent: item,
                            grupo: item.GRUPOCOLABORADORES,
                            vendedor: item.VENDEDOR,
                            usuarioi: item.USUARIOI
                        })
                })

                setDates(eachDayOfInterval({
                    start: _iniDate,
                    end: _finDate
                }))

                setDatesInWeek(eachDayOfInterval({
                    start: startOfWeek(_iniDate),
                    end: endOfWeek(_iniDate)
                }))

                let soma = 0
                setEvents(_aux)

                response.data.tecnicos.map((data) => {
                    return soma += data.TOTAL
                });

                const _colaboradores = response?.data?.tecnicos.filter((item) => !grupo || grupo === "Todos" || grupo === item.GRUPO || grupo == item.GRUPOCOLABORADORES)
                setTotalEvents(soma)
                setColaboradores(_colaboradores)
                setColaboradoresList(response.data.tecnicos)
                setLoading(false)

                const _grupos = response.data.agendamentos.map(registro => registro.GRUPOCOLABORADORES)
                    .filter((valor, indice, array) => array.indexOf(valor) === indice)
                    .filter((valor) => valor !== null)
                setGrupos(_grupos)
            })
            .catch(error => {
                console.log(error)
                setLoading(false)
            })
    }

    const Reduce = async (idtecnico) => {
        let _idtecnico

        if (getUser() === 0) {
            setIdTecnico(idtecnico)
            _idtecnico = idtecnico
        } else {
            setIdTecnico(getUser())
            _idtecnico = getUser()
        }

        let _aux = []
        let _events = []

        if (_idtecnico) {
            _aux = agendamentos.filter((item) => {
                return (parseInt(item.TECNICOID) === parseInt(_idtecnico) && (!grupo || item.GRUPOCOLABORADORES === grupo))
            })
        } else
            _aux = agendamentos.filter((item) => {
                return (!grupo || item.GRUPOCOLABORADORES === grupo)
            })


        if (grupo !== '') {
            let _colaboradores = colaboradoresList.filter((item) => {
                return (item.GRUPOCOLABORADORES === grupo)
            })
            setColaboradores(_colaboradores)
        }
        else
            setColaboradores(colaboradoresList)

        let _tipo = []
        tipoAgendamento.map((item) => {
            if (item.CHECKED === true)
                _tipo.push(item.NOME)

            return (false)
        })


        if (_tipo.length > 0) {
            _aux = _aux.filter((item) => {

                return (_tipo.includes(item.TIPO))
            })
        }

        setEvents([])
        let _a = []
        let iTotal = 0
        _aux.map((item) => {
            iTotal += 1

            let _check = _a.filter(_total => _total.TECNICOID === item.TECNICOID)
            if (_check.length === 0) {
                _a.push({
                    TECNICOID: item.TECNICOID,
                    TECNICO: item.TECNICO,
                    TOTAL: 1
                })
            } else {
                let _find = _a.find(x => x.TECNICOID === item.TECNICOID)
                _find.TOTAL = _find.TOTAL + 1
            }

            if (item)
                return _events.push({
                    id: item.AGENDAID,
                    resourceId: item.TECNICOID,
                    tecnico: item.TECNICO,
                    color: '#' + item.COR,
                    textColor: ["ffff"].includes(item?.COR?.substring(0, 4).toLowerCase()) ? '#000' : '#fff',
                    starthour: item.HORA_INI,
                    start: item.DATA_INI.substring(0, 10) + 'T' + item.HORA_INI,
                    end: item.DATA_FIN === null ? '' : item?.DATA_FIN.substring(0, 10) + 'T' + item.HORA_FIN,
                    title: item.CLIENTE === null ? "(Cliente Não Informado)" : titleCase(item.CLIENTE),
                    dataEvent: item
                })
        })
        setEvents(_events)
        setTotalEvents(iTotal)
        //console.log(colaboradores)
        // setColaboradoresList(_a)
    }

    const titleCase = (str) => {
        var splitStr = str.toLowerCase().split(' ');
        for (var i = 0; i < splitStr.length; i++) {
            splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
        }
        return splitStr.join(' ');
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        getTipoAgendamento()
    }, [])

    useEffect(() => {
        Filters(idTecnico)
    }, [grupo])

    useEffect(() => {

        if (getUser() !== 0) {
            Filters(getUser())
        } else {
            Filters(idTecnico)
        }
    }, [idTecnico])

    useEffect(() => {
        if (reload) {
            setReload(false)
            if (getUser() !== 0)
                Filters(getUser())
            else
                Filters(idTecnico)

        }
    }, [reload])

    const List = ({ date }) => {
        let _now = format(new Date(date), 'yyyy-MM-dd')
        let _itens = events.filter(_item => {
            return ((_item.start.substring(0, 10) === _now))
        })

        if (_itens.length > 0) {
            return (
                _itens.map(_item => {
                    return (
                        <div style={{ padding: "5px", display: "flex", alignItems: "center", borderBottom: "1px dashed #cacaca" }}>
                            <div style={{ background: `${_item.color}`, color: `${_item.textColor}`, borderRadius: "50%", width: "10px", height: "10px" }}>
                                &nbsp;
                                &nbsp;
                            </div>
                            <div className="list-data">
                                <div style={{ width: "330px" }}>
                                    {_item.tecnico}
                                </div>
                                <div>
                                    {_item.title}
                                </div>
                            </div>
                        </div>
                    )
                })
            )
        } else {
            return (<div style={{ padding: "5px" }}>Não existe agendamento para essa data</div>)
        }
    }

    const Lines = ({ date, data }) => {

        let _now = format(new Date(date), 'yyyy-MM-dd')
        let _itens = events.filter(_item => {
            if ((_item.end === _item.start) || (_item.end === null))
                return ((_item.start.substring(0, 10) === _now) && (parseInt(_item.resourceId) === parseInt(data.TECNICOID)))
            else
                return (new Date(_now) >= new Date(_item.start)) && (new Date(_now) <= new Date(_item.end)) && (parseInt(_item.resourceId) === parseInt(data.TECNICOID))
        })

        if (_itens.length > 0) {
            return (
                <td className={`td-agenda ${[0, 6].includes(getDay(new Date(date))) ? 'backWeekend' : ''}`}>
                    <div style={{ display: "flex", gap: "2px", width: "100%" }} >
                        <div style={{ background: `${_itens[0].color}`, color: `${_itens[0].textColor}`, borderRadius: "10px", padding: "1px 5px", cursor: "pointer", width: "100%", textAlign: "center" }} title={_itens[0].title + ' - ' + _itens[0].CNPJ_CPF + ' - ' + _itens[0].Cidade + ' - ' + _itens[0].UF} onClick={e => handleEdit(_itens[0])}>
                            {formatName(_itens[0].title.toLowerCase().replace(/\b\w/g, l => l.toUpperCase()), 1)} [{_itens[0].id}]
                        </div>
                        {_itens.length > 1 ? (
                            <div >

                                <Badge className="dropdown-toggle" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" pill variant="primary" style={{ backgroundColor: '#117319', width: "32px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", height: "28px", marginLeft: "-10px", marginTop: "0px", fontSize:"14px" }}>{_itens.length - 1}</Badge>

                                <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    {_itens.map((_client, ix) => {
                                        if (ix > 0)
                                            return (<a className="dropdown-item" href="#" onClick={e => handleEdit(_client)}>{_client.title}</a>)
                                    })}
                                </div>
                            </div>
                        ) : ''}
                    </div>
                </td>
            )
        } else {
            let _new = {
                idtecnico: data.TECNICOID,
                startStr: _now,
                endStr: _now,
            }

            return (<td onClick={e => newShedulling(_new)} className={`td-agenda ${[0, 6].includes(getDay(new Date(date))) ? 'backWeekend' : ''} `}></td>)
        }


    }

    const DayName = (day) => {
        switch (day) {
            case 0: return "Dom"
            case 1: return "Seg"
            case 2: return "Ter"
            case 3: return "Qua"
            case 4: return "Qui"
            case 5: return "Sex"
            case 6: return "Sáb"
            default:
                break;
        }
    }

    const handeCalendarList = (value) => {

        if (value === 4)
            setModalPeriodo(true)
        setIDCalendarList(value)
    }

    const formatName = (name, words) => {
        let _aux = name.split(' ').slice(0, words).join(' ')
        if (_aux.split(' ').length > 1)
            if (_aux.split(' ')[1].toLowerCase() === 'de')
                _aux = name.split(' ').slice(0, 3).join(' ')

        return _aux
    }

    return (
        // 94vh
        <div style={{ overflow: 'hidden ', backgroundColor: '#fff' }}>
            <NotificationContainer />
            <div className={loading ? '' : 'hidden-display'} style={{ justifyContent: "center", width: 100 + "%", height: "90vh", display: "flex", alignItems: "center" }}>
                <ReactLoading type='spin' color='#007bff' height={35} width={35} />
            </div>

            <div className={`containt-agenda ${loading ? 'hidden-display' : ''}`}>
                <Agendamento show={modal} callback={handleCallback} reload={handleReload} dataSet={data} grupo={grupo} colaboradores={colaboradores} />
                <FilterPeriodo show={modalPeriodo} callback={setModalPeriodo} reload={setReload} dataSet={data} periodo={setPeriodo} />

                <div className="box-agenda">
                    <div style={{ gap: "5px", display: "flex", alignItems: "center", marginRight: "5px", }}>
                        <div style={{ borderRight: "1px dashed #cacaca", paddingRight: "10px" }} className="isDesktop">
                            <button title="Novo agendamento" className='btn btn-sm btn-success' onClick={e => newShedulling({
                                idtecnico: 0,
                                startStr: new Date(),
                                endStr: new Date(),
                            })}>
                                <i className='fa fa-plus' />
                            </button>
                        </div>

                        <div style={{ display: 'flex', width: "100%" }} className={`box-nome ${getUser() === 0 ? '' : 'box-nome-colaborador'}`}>
                            <div className="div-search">
                                {!showFilter && (width() === 'mobile') ? '' :
                                    <div style={{ display: "flex" }}>
                                        <div className='filters'>
                                            {tipoAgendamento.map((value, key) => (
                                                <div key={key} onClick={e => handleTipoAgendamento(value)} className="cb-filter ">
                                                    <div style={{ display: "flex", marginRight: '5px' }}>
                                                        <Form.Check type='checkbox' style={{ cursor: "pointer" }} checked={value.CHECKED} name='checkbox-tipoagendamento' />
                                                        <div style={{ backgroundColor: `#${value.COR}`, width: "10px", height: "10px", borderRadius: "50%", margin: "6px 4px 0px 0px", minWidth: "10px" }}></div>
                                                        <div>
                                                            <span>{value.NOME.charAt(0).toUpperCase() + value.NOME.slice(1).toLowerCase()}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>

                                        <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                            <Button className={`btn btn-primary ${tipoAgendamento.filter(_item => _item.CHECKED).length === 0 ? 'hidden' : ''}`} onClick={e => clearFilters(idTecnico)} size="sm" style={{ marginLeft: "5px", width: "80px" }} title="Limpar filtros"><i className="fa fa-ban" /> </Button>
                                        </div>
                                    </div>
                                }
                                <div style={{ display: 'flex', gap: "5px" }}>
                                    <div className='cbx-visualizacao'>
                                        <label>Grupo</label>
                                        <select className="form-select" value={grupo} onChange={e => handleFilter(e.target.value)} style={{ fontSize: "12.8px", color: "#495057" }}>
                                            <option value="">Todos</option>
                                            {grupos?.map((value, key) => {
                                                return (
                                                    <option key={key} value={value} selected={value == grupo}>{value}</option>
                                                )
                                            })}
                                        </select>
                                    </div>

                                    <div className='cbx-visualizacao'>
                                        <label>Tipo de Visualização</label>
                                        <select className="form-select" value={idCalendarList} onChange={e => handeCalendarList(parseInt(e.target.value))} style={{ fontSize: "12.8px", color: "#495057" }}>
                                            <option value="0">Semana</option>
                                            <option value="1">Lista</option>
                                            <option value="2">Lista Semanal</option>
                                            <option value="3">Lista Diária</option>
                                            <option value="4">Calendário Período</option>
                                        </select>
                                    </div>
                                    <div className='isMobile' style={{ marginTop: "12px" }}>
                                        <button title="Novo agendamento" className='btn btn-sm btn-success' onClick={e => newShedulling({
                                            idtecnico: 0,
                                            startStr: new Date(),
                                            endStr: new Date(),
                                        })}>
                                            <i className='fa fa-plus' />
                                        </button>
                                        {(width() === 'mobile') ?
                                            <button type="button" className='btn btn-sm btn-primary' style={{ marginLeft: "5px" }} onClick={e => setShowFilter(!showFilter)}>
                                                <i className='fa fa-bars' />
                                            </button>
                                            : ''}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container-agenda">
                        {idCalendarList === 0 || idCalendarList === 4 ?
                            <div className={`div-agenda`} style={{ overflowX: "auto", marginTop: "15px !important" }}>
                                <table className='table table-striped agenda' style={{ width: "100%", overflowX: "auto" }}>
                                    <thead style={{ borderTop: "1px solid #cacaca", borderLeft: "1px solid #cacaca" }}>
                                        <th className="date-column" style={{ border: "1px solid #cacaca", width: "20%", textAlign: "left", fontSize: "16px", zIndex: "5" }} >Colaboradores</th>
                                        {dates.map((item, idx) => {

                                            return (<th className={`${[0, 6].includes(getDay(new Date(item))) ? 'topWeekend' : ''}  date-column`} style={{ minWidth: "12%", textAlign: "center", border: "1px solid #cacaca" }}>{DayName(getDay(new Date(item)))} - {format(new Date(item), 'dd/MM')}</th>)
                                        })}
                                    </thead>
                                    <tbody>
                                        {colaboradores.map((colab) => {
                                            return (
                                                <tr>
                                                    <td className="date-column" style={{ borderLeft: "1px solid #cacaca" }}>
                                                        <span className="cut-text " style={{ fontSize: "15px" }}>{formatName(colab.TECNICO.toLowerCase().replace(/\b\w/g, l => l.toUpperCase()), 2)}
                                                        </span>
                                                    </td>
                                                    {dates.map((item, idx) => {
                                                        return (<Lines date={item} data={colab} />)
                                                    })}
                                                </tr>
                                            )
                                        })}

                                    </tbody>
                                </table>
                            </div>
                            : ''}
                        {idCalendarList === 1 && (
                            <div className="list-box">
                                {
                                    dates.map((item, idx) => {
                                        return (
                                            <>
                                                <div style={{ fontWeight: "bold", padding: "5px", background: "#cacaca" }}>{DayName(getDay(new Date(item)))} - {format(new Date(item), 'dd/MM')}</div>
                                                <List date={item} />
                                            </>
                                        )
                                    })
                                }
                            </div>
                        )}

                        {idCalendarList === 2 && (
                            <div className="list-box">
                                {
                                    datesInWeek.map((item, idx) => {
                                        return (
                                            <>
                                                <div style={{ fontWeight: "bold", padding: "5px", background: "#cacaca" }}>{DayName(getDay(new Date(item)))} - {format(new Date(item), 'dd/MM')}</div>
                                                <List date={item} />
                                            </>
                                        )
                                    })
                                }
                            </div>
                        )}

                        {idCalendarList === 3 && (
                            <div className="list-box">
                                {
                                    datesInWeek.map((item, idx) => {
                                        return (
                                            <>
                                                <div style={{ fontWeight: "bold", padding: "5px", background: "#cacaca" }}>{DayName(getDay(new Date(dates[0])))} - {format(new Date(dates[0]), 'dd/MM')}</div>
                                                <List date={dates[0]} />
                                            </>
                                        )
                                    })
                                }
                            </div>
                        )}

                    </div>
                </div>
            </div>
        </div>
    )
}